import * as React from 'react';
import { FC } from 'react';

type FooterProps = {};

const Footer: FC<FooterProps> = () => {
  return (
    <footer className="relative z-10 bg-primary p-10">
      <div className="flex flex-col-reverse lg:flex-row uppercase font-light text-xs text-white">
        <div className="flex-1">
          © 2021 EcoSystemic Utopia, All rights reserved.
        </div>
        <div className="flex-1 flex flex-col lg:flex-row space-y-1 mb-4 lg:space-y-0 lg:mb-0 lg:space-x-5">
          {/*<Link to="/terms-and-conditions/">Terms & Conditions</Link>*/}
          {/*<Link to="/privacy-policy/">Privacy Policy</Link>*/}
          {/*<Link to="/cookie-policy/">Cookie Policy</Link>*/}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
